// Client mirror of server/middleware/permissions.js — keep the two in sync.
//
// A user MAY carry a `permissions` object (per-user overrides). When a key is
// absent (or there's no object at all), the ROLE DEFAULT applies — i.e. exactly
// today's behaviour. Admins always pass every check.

export const PAGE_KEYS = [
  'page.executive',
  'page.channels',
  'page.units_deals',
  'page.leads',
  'page.analytics',
  'page.settings',
  'page.today',
  'page.deal_requests',
  'page.maintenance',
  'page.assistant',
  // Shared team task board — every internal member by default.
  'page.tasks',
  // Director/admin oversight pages (admin+manager by default; grantable per-user).
  'page.brokers',
  'page.commissions',
  'page.stale_leads',
  'page.campaigns',
  'page.project_media',
  'page.closure_tasks',
];

export const ACTION_KEYS = [
  'leads.create',
  'leads.edit',
  'leads.delete',
  'leads.reassign',
  'leads.directive',
  'units.create',
  'units.edit',
  'units.delete',
  'deals.create',
  'deals.edit',
  'deals.delete',
  'deals.request',
  'deals.approve',
  // Broker-company management (the الوسطاء tab): add / edit+enable-disable / delete.
  'brokers.create',
  'brokers.edit',
  'brokers.delete',
  // Team task board: create tasks / edit+comment+move / delete.
  'tasks.create',
  'tasks.edit',
  'tasks.delete',
  'campaigns.create',
  'campaigns.publish',
  'project_media.manage',
];

export const PERMISSION_KEYS = [...PAGE_KEYS, ...ACTION_KEYS];

// Role defaults — reproduce the access each role has TODAY (see backend file
// for the source-of-truth rationale).
const SALES_DEFAULTS = {
  'page.today': true, 'page.leads': true,
  'leads.create': true, 'leads.edit': true,
  'page.deal_requests': true, 'deals.request': true,
  'page.maintenance': true,
  'page.tasks': true, 'tasks.create': true, 'tasks.edit': true,
  'page.closure_tasks': true,
};
const VIEWER_DEFAULTS = {
  'page.executive': true, 'page.channels': true,
  'page.units_deals': true, 'page.leads': true, 'page.analytics': true,
  'page.settings': true, 'page.maintenance': true, 'page.tasks': true,
  'page.closure_tasks': true,
  'leads.create': true, 'leads.edit': true, 'leads.delete': true, 'leads.reassign': true,
};

export function roleDefault(role, key) {
  if (role === 'admin' || role === 'manager') return true;
  if (role === 'sales') return SALES_DEFAULTS[key] === true;
  if (role === 'viewer') return VIEWER_DEFAULTS[key] === true;
  return false;
}

// Does this user have `key`?
export function can(user, key) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const perms = user.permissions;
  if (perms && typeof perms === 'object' && Object.prototype.hasOwnProperty.call(perms, key)) {
    return perms[key] === true;
  }
  return roleDefault(user.role, key);
}
